import { useParams } from 'react-router-dom';
import { useAccountData } from '@trader-dashboard/shared';
import { isDemoAccount, getDemoAccountData } from './demoAccountHelper';
import { AccountData } from '@trader-dashboard/shared';

export const useDemoAwareAccountData = () => {
  const { accountId } = useParams();
  const realAccountData = useAccountData();

  if (isDemoAccount(accountId)) {
    const demo = getDemoAccountData();
    const demoAccountData: AccountData = {
      ...demo,
      accountId: '1',
      lastUpdatedAt: new Date(),
      lastFetchedAt: new Date(),
    };

    return {
      loaded: true,
      accountData: demoAccountData,
      error: undefined,
      refreshAccountData: () => {},
    };
  }

  return realAccountData;
};
